import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { StoreService } from '../services/store.service';
import { decompress } from 'lz-string';
import { MOBILITY_LOGO } from '../Utility/constants';
import { LOGO_TO_DISPLAY } from 'src/startup';
import { environment } from 'src/environments/environment';

@Directive({
	selector: '[appFallbackSrc]',
})
export class FallbacksrcDirective {
	fallbackSrc = LOGO_TO_DISPLAY;

	constructor(private _ss: StoreService, private renderer: Renderer2, private el: ElementRef<HTMLImageElement>) {
		if (!_ss.CustomerInformation) {
			const ls = localStorage.getItem('CustomerInformation');
			console.log({ ls });
			if (ls) {
				_ss.CustomerInformation = JSON.parse(decompress(ls));
			}
		}

		if (this._ss.CustomerInformation.DisplayLogo === '1') {
			this.fallbackSrc = `${this._ss.CustomerInformation.CustImageDomain}/companylogo.jpg`;
		}
		if (this._ss.CustomerInformation.DisplayLogo?.length > 2) {
			this.fallbackSrc = `${this._ss.CustomerInformation.CustImageDomain}/${this._ss.CustomerInformation.DisplayLogo}`;
		}
	}

	@HostListener('error') onError() {
		// early return if fallbackSrc is already set
		if (this.el.nativeElement.src.includes(this.fallbackSrc)) {
			return;
		}

		// if companylogo doesn't exist or network error
		if (this.el.nativeElement.src.includes('companylogo')) {
			this.fallbackSrc = LOGO_TO_DISPLAY;
		}

		this.renderer.setAttribute(this.el.nativeElement, 'src', this.fallbackSrc);
	}
}
